import { useTranslation } from 'react-i18next';
import { TextField } from '@efexteam/components';
import { Box, Typography, Grid, FormControl } from '@mui/material';
import clsx from 'clsx';
import { RateValidationAlert } from '../RateValidationAlert';
import { usePromoterRateInput } from './hooks';
import { PromoterRateInputProps } from './PromoterRateInput.types';
import PromoterRateInputStyles from './PromoterRateInput.styles';

export const PromoterRateInput = ({
  currency,
  clientCurrency,
  exchangeData,
  promoterId,
  enterpriseId,
  currentAmount,
  isReverse,
  rateReference,
  onRateChange,
  onRateClear,
  onValidationChange,
  className,
  disabled = false,
}: PromoterRateInputProps) => {
  const { t } = useTranslation();

  const {
    rateInput,
    baseValidationMessage,
    alertProps,
    handleRateChange,
    hookError,
  } = usePromoterRateInput({
    exchangeData,
    promoterId,
    enterpriseId,
    currentAmount,
    isReverse,
    rateReference,
    currency,
    clientCurrency,
    onRateChange,
    onRateClear,
    onValidationChange,
  });

  if (hookError) {
    return (
      <Box className={clsx(PromoterRateInputStyles.mainContainer, className)}>
        <Typography color="error" variant="body2">
          {t('errorLoadingRateInput')}: {hookError}
        </Typography>
      </Box>
    );
  }

  return (
    <div className={clsx(PromoterRateInputStyles.mainContainer, className)}>
      <Grid container>
        <Typography className={PromoterRateInputStyles.labelText}>
          {t('finalExchangeRate')}
        </Typography>
        <Grid item xs={10}>
          <FormControl fullWidth>
            <TextField
              size="small"
              id="finalExchangeRate"
              name="finalExchangeRate"
              placeholder="0.00"
              value={rateInput}
              disabled={disabled}
              aria-label={t('finalExchangeRate') || ''}
              helperText={baseValidationMessage}
              onChange={handleRateChange}
            />
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <div className={PromoterRateInputStyles.rightPlaceholder} />
        </Grid>
      </Grid>

      <RateValidationAlert alertProps={alertProps} />
    </div>
  );
};

PromoterRateInput.displayName = 'PromoterRateInput';

export default PromoterRateInput;
